import React from 'react'
import { useIsCityVariant } from '@hooks/useIsCityVariant'
import { CityTreatment } from './CityTreatment'
import { ClinicTreatment } from './ClinicTreatment'
import { useSendTreatmentEvent } from '@hooks/useSendTreatmentEvent'
import { useIsAllClinicsVariant } from '@hooks/useIsAllClinicsVariant'
import { AllClinicsTreatments } from './AllClinicsTreatments'

export const Treatment = () => {
  const isCityVariant = useIsCityVariant()
  const isAllClinicsVariant = useIsAllClinicsVariant()
  useSendTreatmentEvent()

  const screen = (() => {
    if (isCityVariant) return <CityTreatment />
    if (isAllClinicsVariant) return <AllClinicsTreatments />
    return <ClinicTreatment />
  })()

  return screen
}
